/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderMinusIcon32Regular = forwardRef('FolderMinusIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M11 17a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H11Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 3A3.5 3.5 0 0 0 2 6.5v17A5.5 5.5 0 0 0 7.5 29h17a5.5 5.5 0 0 0 5.5-5.5v-11A5.5 5.5 0 0 0 24.5 7h-7.25a1.5 1.5 0 0 1-1.2-.6l-1.5-2a3.5 3.5 0 0 0-2.8-1.4H5.5ZM4 6.5A1.5 1.5 0 0 1 5.5 5h6.25a1.5 1.5 0 0 1 1.2.6l1.5 2a3.5 3.5 0 0 0 2.8 1.4h7.25a3.5 3.5 0 0 1 3.5 3.5v11a3.5 3.5 0 0 1-3.5 3.5h-17A3.5 3.5 0 0 1 4 23.5v-17Z" })));
});
